import SegmentChain from "./segmentChain";
import { findIntersectionLastSegment, findIntersectionClosingSegment, polygonArea } from "../geometry";

export default class SegmentChainArea extends SegmentChain {
  constructor(position, options){
    super(position, options);

    this.closed = false;
    this.area = 0;
  }

  mousemove(x, y){
    let numPoints = this.points.length;
    super.mousemove(x, y);
    if (this.points.length != numPoints) this.checkForIntersection();
  }

  mouseup(){
    super.mouseup();
    if (!this.closed) this.closeChain();
  }

  checkForIntersection(){
    let {index, intersect} = findIntersectionLastSegment(this.points);
    this.truncateIntersectionIfFound(index, intersect);
  }

  closeChain() {
    let {index, intersect} = findIntersectionClosingSegment(this.points);
    this.truncateIntersectionIfFound(index, intersect);
    if (!intersect) this.setClosedPoint(this.points[0]);
  }

  truncateIntersectionIfFound(index, intersect) {
    if (intersect && index >= 0) {
      if (index > 0) this.points = this.points.slice(index);
      // pop the last point to replace it with the intersect
      // this avoids weird little stubby bits if the last segment was long
      this.points.pop();
      this.setClosedPoint(intersect);
    }
  }

  setClosedPoint(point){
    this.points[0] = Object.assign({}, point);
    this.points.push(Object.assign({}, point));
    this.recalculateBounds();
    this.area = polygonArea(this.points);
    this.drawingInitialLine = false;
    this.closed = true;
  }
}